// GraphIconButton.js
import React from 'react';
import {LineChartIcon} from 'lucide-react'; // or any icon library you prefer

const GraphIconButton = ({ onClick, tooltip = "View trend" }) => (
    <button onClick={onClick} title={tooltip} style={{ marginLeft: '6px', background: 'none', border: 'none', cursor: 'pointer' }}>
        <LineChartIcon size={16} />
    </button>
);

export default GraphIconButton;
